import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Table, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import style from './index.scss';
import get from 'lodash/get';
import { MODULE_SOURCEID_MAPPING } from '../../../../../util/GlobalConstant';

export const DrawerDMC = ({
  visible,
  close,
  select,
  isLoading,
  mcData,
  getNSMatchingConfigListData,
  createUpdateRunInstanceConfig,
  authentication
}) => {
  const [rowValue, setRowValue] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [pageSize, setPagesize] = useState(5);
  const [matchingConfigfilter, setMatchingConfigfilter] = useState(null);

  const sourceId =
    MODULE_SOURCEID_MAPPING[
      get(authentication, 'currentProductLogin.moduleCode')
    ] || '';

  useEffect(() => {
    let payload = {
      offset: 0,
      limit: 1000,
      sourceId // To retain selection in pages even if we switch page
    };

    getNSMatchingConfigListData(payload);
  }, [matchingConfigfilter]);

  let mcDataTable = {
    columns: [
      {
        title: 'Matching Configuration Name',
        dataIndex: 'name'
      },
      {
        title: 'Module',
        dataIndex: 'type'
      }
    ]
  };

  let mycol = [];
  mcData?.payload?.map((item) => {
    if (item?.sourceIds == '16' || item?.sourceIds == '17') {
      if (
        item.sourceIds ==
        createUpdateRunInstanceConfig?.runInstanceConfig?.sourceId
      ) {
        mycol = [
          ...mycol,
          { key: item.id, name: item.name, id: item.id, type: item.type }
        ];
      }
    } else {
      mycol = [
        ...mycol,
        { key: item.id, name: item.name, id: item.id, type: item.type }
      ];
    }
  });
  mcDataTable.dataSource = mycol;

  const onRowSelectionHandler = (selectedRowKeys, selectedRows) => {
    setRowValue(selectedRows);
    setBtnDisabled(false);
  };

  const onApply = () => {
    select(rowValue);
    close();
    setBtnDisabled(true);
  };

  //handling close Drawer
  const setDrawerClose = () => {
    setMatchingConfigfilter(null);
    setBtnDisabled(true);
    close();
  };

  const showTotal = (total) => `${total} Records`;

  const onPaginationChange = (page, newPageSize) => {
    setPagesize(newPageSize);
  };

  return (
    <Fragment>
      <Drawer
        id="mcDrawer"
        title="Select Matching Configuration"
        width={'650px'}
        onClose={setDrawerClose}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        headerStyle={{ borderBottom: '0px hidden' }}
        visible={visible}
        bodyStyle={{ paddingBottom: 0 }}>
        <label className={style.label}>Matching Configuration</label>
        <br />

        <div className={style.table_wrapper}>
          <Table
            rowSelection={{
              type: 'radio',
              onChange: onRowSelectionHandler
            }}
            loading={isLoading}
            columns={mcDataTable.columns}
            dataSource={mcDataTable.dataSource}
            pagination={{
              pageSize: pageSize,
              showTotal: showTotal,
              showSizeChanger: true,
              showLessItems: true,
              pageSizeOptions: [5, 10, 25, 50, 100],
              onChange: onPaginationChange
            }}
          />
        </div>

        <div className={style.applyBtnHolder}>
          <Button
            className={style.Button}
            type="primary"
            id="mcApply-btn"
            onClick={onApply}
            disabled={btnDisabled}>
            Apply
          </Button>
        </div>
      </Drawer>
    </Fragment>
  );
};

DrawerDMC.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  mcData: PropTypes.object,
  getNSMatchingConfigListData: PropTypes.func,
  createUpdateRunInstanceConfig: PropTypes.object,
  authentication: PropTypes.object
};

export default DrawerDMC;
